export const IDEA_STATUSES = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
} as const;

export type IdeaStatus = (typeof IDEA_STATUSES)[keyof typeof IDEA_STATUSES];

export const IDEA_STATUS_VALUES = Object.values(IDEA_STATUSES) as [IdeaStatus, ...IdeaStatus[]];

const TRANSITIONS: Record<IdeaStatus, readonly IdeaStatus[]> = {
  [IDEA_STATUSES.PENDING]: [IDEA_STATUSES.APPROVED, IDEA_STATUSES.REJECTED],
  [IDEA_STATUSES.APPROVED]: [],
  [IDEA_STATUSES.REJECTED]: [],
};

export const ALLOWED_TRANSITIONS: Readonly<Record<IdeaStatus, readonly IdeaStatus[]>> = Object.freeze(TRANSITIONS);

export const TERMINAL_STATUSES: readonly IdeaStatus[] = [IDEA_STATUSES.APPROVED, IDEA_STATUSES.REJECTED];

export function canTransition(from: IdeaStatus, to: IdeaStatus): boolean {
  return ALLOWED_TRANSITIONS[from].includes(to);
}

export function isClosed(status: IdeaStatus): boolean {
  return TERMINAL_STATUSES.includes(status);
}

export function nextStatuses(from: IdeaStatus): readonly IdeaStatus[] {
  return ALLOWED_TRANSITIONS[from];
}
